import BANK from "./bank.png";
import BAS from "./bas.jpg";
import BASE_HEADER from "./base-header.png";
import CHECKCREDIT_DISABLED_HEADER from "./check-credit-header-disabled.png";
import CHECKCREDIT_HEADER from "./check-credit-header.png";
import CHECK_CREDIT from "./check-credit.png";
import CHECKMARK from "./check-mark-png.png";
import CREDITCARD from "./credit-card.png";
import DEBITCARD from "./debit-card.png";
import EHANDEL from "./e-handel.jpg";
import FORETAGARNA_BANK_CARD_HAND from "./foretagarna-bank-card-hand.jpg";
import FORETAGARNA_BANKKORT from "./foretagarna-bankkort.jpg";
import FORETAGARNA_DASHBOARD from "./foretagarna-dashboard.png";
import FORETAGARNA_DEBIT from "./foretagarna-debit.png";
import FORETAGARNA_CREDIT from "./foretagarna-kredit.png";
import FORETAGARNA_LOGO from "./foretagarna-logo.svg";
import FORETAGARNA from "./foretagarna.jpg";
import GRATIS_BANKINTYG from "./gratis_bankintyg.svg";
import GROW_HEADER from "./grow-header.png";
import GROW from "./grow.jpg";
import HEROLOGIN from "./hero-login.jpg";
import PROMO_CREDIT_INTEREST from "./promo-credit-interest.jpg";

export const Images = {
	HEROLOGIN,
	DEBITCARD,
	CREDITCARD,
	GROW_HEADER,
	BASE_HEADER,
	CHECKCREDIT_HEADER,
	CHECKCREDIT_DISABLED_HEADER,
	CHECKMARK,
	BANK,
	FORETAGARNA,
	EHANDEL,
	GROW,
	BAS,
	FORETAGARNA_DEBIT,
	FORETAGARNA_CREDIT,
	CHECK_CREDIT,
	FORETAGARNA_DASHBOARD,
	GRATIS_BANKINTYG,
	PROMO_CREDIT_INTEREST,
	FORETAGARNA_BANK_CARD_HAND,
	FORETAGARNA_BANKKORT,
	FORETAGARNA_LOGO,
};
